import React from 'react';
import * as style from './style';
import { reset } from '../../../../assets/images';

const OptionCheckboxListWCategories = ({
  wCategories,
  searchOptionTableState,
  setSearchOptionTableState,
}) => {
  const dict = [
    { name: '의류', id: 14 },
    { name: '가방', id: 15 },
    { name: '신발', id: 16 },
    { name: '악세서리', id: 17 },
  ];

  const categoryIdList = searchOptionTableState.categoryIdList;
  const setCategoryIdList = (categoryId) => {
    const loc = categoryIdList.indexOf(categoryId);
    let newCategoryIdList = [];
    if (loc === -1) {
      newCategoryIdList = [...categoryIdList, categoryId];
    } else {
      newCategoryIdList = [
        ...categoryIdList.slice(0, loc),
        ...categoryIdList.slice(loc + 1),
      ];
    }
    setSearchOptionTableState({
      ...searchOptionTableState,
      categoryIdList: newCategoryIdList,
    });
  };

  return (
    <style.Container>
      <style.Title>
        <style.TitleSpan>여성 카테고리</style.TitleSpan>
        <style.ResetButton
          src={reset}
          onClick={() => {
            const wCatSet = new Set(categoryIdList);
            wCategories.forEach(({ id }) => wCatSet.delete(id));
            setSearchOptionTableState({
              ...searchOptionTableState,
              categoryIdList: [...wCatSet.values()],
            });
          }}
        />
      </style.Title>
      <style.Content>
        <style.CheckboxContainer>
          <style.Checkbox
            onClick={() => {
              const wCatSet = new Set(categoryIdList);
              if (wCategories.every(({ id }) => wCatSet.has(id))) {
                wCategories.forEach(({ id }) => wCatSet.delete(id));
                setSearchOptionTableState({
                  ...searchOptionTableState,
                  categoryIdList: [...wCatSet.values()],
                });
              } else {
                wCategories.forEach(({ id }) => wCatSet.add(id));
                setSearchOptionTableState({
                  ...searchOptionTableState,
                  categoryIdList: [...wCatSet.values()],
                });
              }
            }}
            checked={wCategories.every(({ id }) => categoryIdList.includes(id))}
          />
          <style.Label>전체선택</style.Label>
        </style.CheckboxContainer>
        {dict.map((subCategory) => (
          <>
            <style.CheckboxContainer>
              <style.Checkbox
                onClick={() => {
                  const allSubCatIds = wCategories
                    .filter((obj) => obj.parentId === subCategory.id)
                    .map((obj) => obj.id);
                  const wCatSet = new Set(categoryIdList);
                  if (allSubCatIds.every((id) => wCatSet.has(id))) {
                    allSubCatIds.forEach((id) => wCatSet.delete(id));
                    setSearchOptionTableState({
                      ...searchOptionTableState,
                      categoryIdList: [...wCatSet.values()],
                    });
                  } else {
                    allSubCatIds.forEach((id) => wCatSet.add(id));
                    setSearchOptionTableState({
                      ...searchOptionTableState,
                      categoryIdList: [...wCatSet.values()],
                    });
                  }
                }}
                checked={wCategories
                  .filter((obj) => obj.parentId === subCategory.id)
                  .map((obj) => obj.id)
                  .every((id) => categoryIdList.includes(id))}
              />
              <style.Initial>{subCategory.name}</style.Initial>
            </style.CheckboxContainer>
            {wCategories
              .filter((obj) => obj.parentId === subCategory.id)
              .map((obj, index) => (
                <style.CheckboxContainer key={index}>
                  <style.Checkbox
                    onClick={() => setCategoryIdList(obj.id)}
                    checked={categoryIdList.includes(obj.id)}
                  />
                  <style.Label>{obj.name}</style.Label>
                </style.CheckboxContainer>
              ))}
          </>
        ))}
      </style.Content>
    </style.Container>
  );
};

export default OptionCheckboxListWCategories;
